"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var local_workspace_repository_1 = require("./local-workspace-repository");
var redi_window_container_web_lib_1 = require("redi-window-container-web-lib");
var LocalWorkspaceWindowRepository = /** @class */ (function () {
    function LocalWorkspaceWindowRepository() {
    }
    LocalWorkspaceWindowRepository.prototype.getOrCreate = function (name, defaultLayout, defaultData) {
        return local_workspace_repository_1.localWorkspaceRepository.update(function (workspace) {
            var id = redi_window_container_web_lib_1.windowContainerApi.currentWindowName;
            return workspace.getOrCreateWindow(name, id, defaultLayout, defaultData);
        });
    };
    LocalWorkspaceWindowRepository.prototype.isExisting = function (name, id) {
        var workspace = local_workspace_repository_1.localWorkspaceRepository.getOrCreate();
        var workspaceWindow = workspace.getWindow(name, id);
        return !!workspaceWindow && !workspaceWindow.isNewWindow();
    };
    LocalWorkspaceWindowRepository.prototype.set = function (workspaceWindow) {
        local_workspace_repository_1.localWorkspaceRepository.update(function (workspace) {
            return workspace.setWindow(workspaceWindow);
        });
    };
    LocalWorkspaceWindowRepository.prototype.update = function (name, defaultLayout, defaultData, updater) {
        var workspaceWindow = this.getOrCreate(name, defaultLayout, defaultData);
        var result = updater(workspaceWindow);
        this.set(workspaceWindow);
        return result;
    };
    return LocalWorkspaceWindowRepository;
}());
exports.LocalWorkspaceWindowRepository = LocalWorkspaceWindowRepository;
exports.localWorkspaceWindowRepository = new LocalWorkspaceWindowRepository();



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/business/local-workspace-window-repository.js
// module id = 138
// module chunks = 0